import { render, staticRenderFns } from "./SearchDesktop.vue?vue&type=template&id=0ad8a89e"
import script from "./SearchDesktop.vue?vue&type=script&lang=js"
export * from "./SearchDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports